module.exports = __webpack_public_path__ + "static/media/41.203ac82c.jpg";